/** A small constellation: a few stars joined by thin lines. */
const KnowledgeMapIcon = () => (
  <svg
    aria-hidden="true"
    fill="none"
    height="18"
    viewBox="0 0 24 24"
    width="18"
  >
    <path
      d="M5 17 10 7l5 6 4-8M10 7l9-2M5 17l10-4"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeOpacity="0.55"
      strokeWidth="1.25"
    />
    <circle cx="5" cy="17" fill="currentColor" r="2" />
    <circle cx="10" cy="7" fill="currentColor" r="1.75" />
    <circle cx="15" cy="13" fill="currentColor" r="1.5" />
    <circle cx="19" cy="5" fill="currentColor" r="1.75" />
  </svg>
);

export default KnowledgeMapIcon;
